module.exports = __webpack_public_path__ + "static/media/logo_color.c6847bd3.png";